// import React from 'react'
// import escapeHtml from 'escape-html'
// import {FontFamilyDefault} from '../common/FontFamilyList'
import {FontSizeDefault} from '../common/FontSizeList'
import { Node, Text } from 'slate'
import { FontFamilyDefault } from '../common/FontFamilyList';

const fontSizeToEm = (fontSize) => {
	return (fontSize / 10).toString() + 'em';
}

// Define a deserializing function that takes a string and returns a value.
const deserialize = string => {
	// Return a value array of children derived by splitting the string.
	return string.split('\n').map(line => {
	  return {
		children: [{ text: line }],
	  }
	})
}

// Define a serializing function that takes a value and returns a string.
const serializeToPlainText = nodes => {
	if(nodes.length > 0) {
		  return nodes.map(n => Node.string(n)).join('\n')
	} else {
		return null;
	}
}

const serializeToHtml = (nodes, vars, showWriterFont = true, storyDefaultFontStyle = {}, userFontStyle = {}, changeFontSize=0) => {
	if(nodes.length > 0) {
		return nodes.map((node, index) => {
			return serializeNodeToHtml(node, vars, showWriterFont, storyDefaultFontStyle, userFontStyle, changeFontSize, index, 0, node.children.length);
		})
	} else {
		return null;
	}
}

const serializeNodeToHtml = (node, vars={}, showWriterFont=true, storyDefaultFontStyle={}, userFontStyle={}, changeFontSize=0, nodeIndex=0, childrenIndex=0, length=1) => {
	const key = nodeIndex + '-' + childrenIndex;

	if (Text.isText(node)) {
		const text = node.text;
		if (text === "" && childrenIndex === length - 1) {
			return <br key={key} />
		}
		var fontFamily, color = null;
		var fontSize = FontSizeDefault;
		if (showWriterFont) {
			// Story Fonts
			fontFamily =  node.font_family || storyDefaultFontStyle.fontFamily || FontFamilyDefault;
			fontSize = parseInt(node.font_size) || storyDefaultFontStyle.fontSize || FontSizeDefault;
			color = storyDefaultFontStyle.color || node.font_color || false;
		} else {
			// User Fonts
			fontFamily = userFontStyle.fontFamily ? userFontStyle.fontFamily : false;
			fontSize = (userFontStyle.fontSize ? userFontStyle.fontSize : FontSizeDefault);
			color = (userFontStyle.color ? userFontStyle.color : false);
		}
		fontSize += parseInt(changeFontSize);
		fontSize = fontSizeToEm(fontSize);

		const customFormat = Object.assign({}, 
			fontFamily ? {fontFamily} : {}, 
			fontSize ? {fontSize} : {},
			color ? {color} : {},
		)

		var child = text;
		if(node.bold)
			child = <strong>{child}</strong>
		if(node.italic)
			child = <em>{child}</em>
		if(node.underline || node.underlined)
			child = <u>{child}</u>
		return <span key={key} style={customFormat}>{child}</span>
	}

	const children = node.children.map((n, childrenIndex) => {
		return serializeNodeToHtml(n, vars, showWriterFont, storyDefaultFontStyle, userFontStyle, changeFontSize, nodeIndex, childrenIndex, length)
	})

	var blockquoteBorder = {}
	if(!showWriterFont) {
		if(userFontStyle.color) {
			blockquoteBorder = {
				borderLeft: '2px solid ' + userFontStyle.color
			}
		}
	} else {
		if(storyDefaultFontStyle.color) {
			blockquoteBorder = {
				borderLeft: '2px solid ' + storyDefaultFontStyle.color
			}
		}
	}

	switch (node.type) {
		case 'quote':
			return <blockquote key={key} style={blockquoteBorder}>{children}</blockquote>
		case 'block-quote':
			return <blockquote key={key} style={blockquoteBorder}>{children}</blockquote>
		case 'paragraph':
			return <p key={key}>{children}</p>
		case 'numbered-list':
			return <ol key={key}>{children}</ol>
		case 'bulleted-list':
			return <ul key={key}>{children}</ul>
		case 'list-item':
			return <li key={key}>{children}</li>
		case 'heading-one':
			return <h1 key={key}>{children}</h1>
		case 'heading-two':
			return <h2 key={key}>{children}</h2>
		case 'indent':
			return <span key={key} style={{paddingLeft: '25px', display: 'inline'}}></span>
		case 'varMention':
			if(vars[node.character]) {
				var fontFamily2, color2 = null;
				var fontSize2 = FontSizeDefault;
				if (showWriterFont) {
					// Story Fonts
					fontFamily2 =  node.font_family || storyDefaultFontStyle.fontFamily || FontFamilyDefault;
					fontSize2 = parseInt(node.font_size) || storyDefaultFontStyle.fontSize || FontSizeDefault;
					color2 = storyDefaultFontStyle.color || node.font_color || false;
				} else {
					// User Fonts
					fontFamily2 = userFontStyle.fontFamily ? userFontStyle.fontFamily : false;
					fontSize2 = (userFontStyle.fontSize ? userFontStyle.fontSize : FontSizeDefault);
					color2 = (userFontStyle.color ? userFontStyle.color : false);
				}
				fontSize2 += parseInt(changeFontSize);
				fontSize2 = fontSizeToEm(fontSize2);

				const customFormat2 = Object.assign({}, 
					fontFamily2 ? {fontFamily: fontFamily2} : {}, 
					fontSize2 ? {fontSize: fontSize2} : {},
					color2 ? {color: color2} : {},
				)
				return (
					<span key={key} style={customFormat2}>
						{vars[node.character].value}
					</span>
				);
			}
			return 
		default:
			return children
	}
}

const getVarMentions = (nodes) => {
	var varsUsed = [];
	
	for(const node of nodes) {
		getNodeVarMentions(node, varsUsed)
	}

	return Array.from(new Set(varsUsed));
}

const getNodeVarMentions = (node, varsUsed=[]) => {
	if(node.type === "varMention" && node.character) {
		varsUsed.push(node.character);
	} 

	if(!node.children) {
		return;
	}

	for(var child of node.children) {
		getNodeVarMentions(child, varsUsed);
	}
}

export {
	deserialize,
    serializeToPlainText,
    serializeToHtml,
	fontSizeToEm,
	getVarMentions,
};